import { configureStore } from "@reduxjs/toolkit";

import bookingSlice from "./booking-slice";
import quoteSlice from "./quote-slice";
import formSlice from "./form-slice";
import popupSlice from "./popup-slice";
import ratesSlice from "./rates-slice";

const store = configureStore({
  reducer: {
    booking: bookingSlice.reducer,
    quote: quoteSlice.reducer,
    form: formSlice.reducer,
    popup: popupSlice.reducer,
    rates: ratesSlice.reducer,
  },
});

export default store;
